import React, { useCallback } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import { image } from '../../../utils/data/baseUrl';
import { gamesList, inactiveGameModalContent } from '../../../constants/copyright';
import { useContent } from '../../../redux/reducer/content';
import { useUser } from '../../../redux/reducer/user';
import { useTranslation } from '../../../translations';

const LoseModal = React.forwardRef(function LoseModal(
  { title, text, buttons, reset, quizAnswersData, goHome, gameType, end, callbacks: appCallbacks, infiniteLevels },
  ref,
) {
  const truth = quizAnswersData?.truth;
  const wrong = quizAnswersData?.wrong;
  const { closeModal } = useModal();
  const { gamesSettings } = useContent();
  const { list } = gamesList;
  const { profile } = useUser();
  const { addModal } = useModal();
  const close = useCallback(() => closeModal({ type: 'all' }), []);
  const game = gamesSettings?.find((game) => game.name.toLowerCase() === gameType);
  const { t } = useTranslation();

  const callbacks = {
    reset: () => {
      close();

      const lowEnergy = gameType && profile?.attempts < game?.energy;

      if (lowEnergy && !infiniteLevels) {
        addModal({
          type: 'inactiveGameModal',
          props: {
            className: 'about-modal_inactive',
            img: list[gameType].image,
            title: inactiveGameModalContent.title,
            description: inactiveGameModalContent.text,
            buttons: inactiveGameModalContent.buttons,
            callback: () => end?.(),
          },
        });
        return;
      }

      reset?.();
    },
    home: () => {
      end?.();
      goHome?.();
      close();
    },
  };

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={'lose-modal'} ref={ref}>
        <div className={'lose-modal__bg'} />
        <div className={'lose-modal__content'}>
          <h2 className={'lose-modal__title'}>{safeHTML(t(title))}</h2>
          {quizAnswersData && (
            <div className='lose-modal__info'>
              <div className='lose-modal__info-item'>
                <img className='lose-modal__info-item-image' src={image('wrong.svg')} />
                <span className='lose-modal__info-item-text'>
                  {wrong} {t('other.wrong')}
                </span>
              </div>
              <div className='lose-modal__info-item'>
                <img className='lose-modal__info-item-image' src={image('right.svg')} />
                <span className='lose-modal__info-item-text'>
                  {truth} {t('other.correct')}
                </span>
              </div>
            </div>
          )}
          <p className='lose-modal__text'>{safeHTML(t(text))}</p>
          {buttons.map(({ attr, action }, id) => (
            <CustomButton disposable={true} key={`b-${id}`} {...attr} onClick={callbacks[action]} />
          ))}
        </div>
      </div>
    </CustomModal>
  );
});

export default LoseModal;
LoseModal.propTypes = {};
